<template>
  <div class="brand-list-page">
    <Create
      :createDialog="createDialog"
      @close="createDialog = false"
      @submit="getList"
    />

    <Edit
      :editDialog="editDialog"
      @close="editDialog = false"
      @submit="getList"
      :editBrand="selectedBrand"
    />

    <v-card :loading="loading" outlined class="brand-card">
      <div class="brand-header">
        <div>
          <div class="brand-title">Brand</div>
          <div class="brand-subtitle">
            {{ Brands.length }} brands found
          </div>
        </div>

        <v-btn small rounded color="primary" dark @click="add">
          <v-icon left small>mdi-plus</v-icon>
          New Brand
        </v-btn>
      </div>

      <div class="brand-filter-bar">
        <div class="filter-field">
          <div class="filter-label">Search Brand</div>
          <v-text-field
            v-model="search"
            outlined
            prepend-inner-icon="search"
            dense
            label="Brand name"
            single-line
            hide-details
            clearable
            class="brand-search"
          />
        </div>
      </div>

      <v-card-text class="pa-4">
        <v-data-table
          :mobile-breakpoint="0"
          :headers="headers"
          :items="Brands"
          :search="search"
          :loading="loading"
          :sort-by="sortBy"
          :page.sync="page"
          :items-per-page="itemsPerPage"
        >
          <template v-slot:item="{ item }">
            <tr class="pointer">
              <td class="text-left font-weight-medium">
                {{ item.name }}
              </td>

              <td class="justify-end align-center text-right">
                <v-menu bottom left offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon>
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>

                  <v-list dense class="menu-button">
                    <v-list-item @click="editBrand(item)">
                      <v-list-item-title>Edit</v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="deleteBrand(item)">
                      <v-list-item-title>Delete</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>

          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import brandService from "@/modules/Product/Brand/service.js";

const Create = () => import("./Create");
const Edit = () => import("./Edit");

export default {
  name: "brand-list",

  components: {
    Create,
    Edit,
  },

  data() {
    return {
      createDialog: false,
      editDialog: false,
      selectedBrand: null,
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name",
          sortable: true,
        },
        {
          text: "",
          value: "action",
          sortable: false,
        },
      ],
      Brands: [],
      search: "",
      loading: true,
      page: 1,
      sortBy: "name",
      pageCount: 0,
      itemsPerPage: 10,
    };
  },

  created() {
    this.getList();
    document.title = "smplsale - Brand List";
  },

  methods: {
    add() {
      this.createDialog = true;
    },

    getList() {
      this.loading = true;
      this.editDialog = false;
      this.createDialog = false;

      return brandService
        .getAll()
        .then((response) => {
          this.Brands = response.data || [];
          return response;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    editBrand(brand) {
      this.selectedBrand = brand;
      this.editDialog = true;
    },

    deleteBrand(brand) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          brandService.delete(brand.id).then((response) => {
            if (response.data) {
              this.$swal("Deleted!", "Brand has been deleted.", "success");
              this.getList();
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.brand-list-page {
  width: 100%;
}

.brand-card {
  border-radius: 20px;
  background: #ffffff;
  overflow: hidden;
}

.brand-header {
  padding: 16px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.brand-title {
  font-size: 22px;
  font-weight: 800;
  color: #0f172a;
}

.brand-subtitle {
  font-size: 13px;
  color: #64748b;
  margin-top: 2px;
}

.brand-filter-bar {
  padding: 12px 16px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: flex-end;
  gap: 12px;
  flex-wrap: wrap;
}

.filter-field {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.filter-label {
  font-size: 11px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.brand-search {
  width: 360px;
  max-width: 100%;
}

.pointer:hover {
  background: #f8fafc;
}

@media (max-width: 600px) {
  .brand-header .v-btn {
    width: 100%;
  }

  .brand-search {
    width: 100%;
  }

  .filter-field {
    width: 100%;
  }
}
</style>